import { isValuePresent } from '../../helpers';

var isMatching = function isMatching(value, regExpOptions) {
  return new RegExp(regExpOptions.source, regExpOptions.options).test(value);
};

var hasValidFormat = function hasValidFormat(value, withOptions, withoutOptions) {
  return withOptions && isMatching(value, withOptions) || withoutOptions && !isMatching(value, withoutOptions);
};

export var formatLocalValidator = function formatLocalValidator($element, options) {
  var value = $element.val();

  if (options.allow_blank && !isValuePresent(value)) {
    return;
  }

  if (!hasValidFormat(value, options.with, options.without)) {
    return options.message;
  }
};
export default {
  formatLocalValidator: formatLocalValidator
};